var lib_core = require("lib-core");

var PanningModel = function () {
    lib_core.Model.apply(this);
};
lib_core.inherit(PanningModel, lib_core.Model);
lib_core.JsonParser.registerClass(PanningModel, "PanningModel");

module.exports = PanningModel;

/**
 * @param   {number}       x
 * @param   {number}       y
 * @param   {number}       s
 */
PanningModel.prototype.changeView = function(x, y, s) {
    if (x != 0) this.parent().viewX(this.parent().viewX() + x);
    if (y != 0) this.parent().viewY(this.parent().viewY() + y);
    if (s != 1) this.parent().viewS(this.parent().viewS() * s);
};

/**
 * @param   {number}       x
 * @param   {number}       y
 * @param   {number}       s
 */
PanningModel.prototype.setView = function(x, y, s) {
    this.parent().viewX(x);
    this.parent().viewY(y);
    this.parent().viewS(s);
};

PanningModel.prototype.onPanStart = function() {
};

PanningModel.prototype.onPanStop = function() {
};

PanningModel.prototype.onPanClick = function() {
};

